import i18n from '@nextroll/ar-i18n';

import PageBanner from '../PageBanner';

const VerifiedView = () => {
    const topText = i18n.gettext('Email address verified!');

    const bottomText = i18n.gettext(
        'Thank you for verifying your email! ' +
            "To improve the security of your account, we've automatically enabled email-based two-factor authentication. " +
            "If you'd prefer, you can set up other authentication options, such as an authenticator app, in your user settings."
    );
    return (
        <div className='eh-ev-form-view-verified'>
            <PageBanner
                animate={true}
                topText={topText}
                bottomText={bottomText}
                className='status-verified'
            />

            <div className='ev-eh-form-view-cta'>
                <a className='btn btn-primary' href='/account/centralredirect'>
                    {i18n.gettext('Continue')}
                </a>
            </div>
        </div>
    );
};

export default VerifiedView;
